/**
 * Lightweight fetch wrapper — drop-in axios replacement.
 * Reads auth token from localStorage on every request (no global mutation).
 * Error objects match axios shape: err.response.data.error
 */

async function request(method, url, data) {
  const token = localStorage.getItem('ax_token');
  const isFormData = data instanceof FormData;

  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (data && !isFormData) headers['Content-Type'] = 'application/json';

  const res = await fetch(url, {
    method,
    headers,
    body: data
      ? isFormData ? data : JSON.stringify(data)
      : undefined,
  });

  // Parse response body
  const contentType = res.headers.get('content-type') || '';
  const body = contentType.includes('application/json')
    ? await res.json()
    : await res.text();

  if (!res.ok) {
    const err = new Error(
      (typeof body === 'object' ? body?.error || body?.message : body) ||
      `HTTP ${res.status}`
    );
    err.response = {
      status: res.status,
      data: typeof body === 'object' ? body : { error: body },
    };
    throw err;
  }

  return { data: body, status: res.status };
}

const api = {
  get:    (url)        => request('GET',    url),
  post:   (url, data)  => request('POST',   url, data),
  put:    (url, data)  => request('PUT',    url, data),
  patch:  (url, data)  => request('PATCH',  url, data),
  delete: (url)        => request('DELETE', url),
  // No-op shim — token is read from localStorage per-request, no global state needed
  defaults: { headers: { common: {} } },
};

export default api;
